import React from 'react'

import Layout from '../../Layout'
import CanceledOrderContainer from '../../../../Components/OrdersPart/CanceledOrderContainer/CanceledOrderContainer'

const AcceptedOrderDelivery = () => {
  return (
    <Layout>
        <CanceledOrderContainer/>
    </Layout>
  )
}

export default AcceptedOrderDelivery